import axios from '../../utils/axios';
import CRUD from './crud'

const ticketPrices = new CRUD('ticket-prices', 'superior-judge')

export default Object.assign(
    ticketPrices,
    {
        reducers: {
            ...ticketPrices.reducers
        },


    }
)
